import React from "react";
import { Modal, Button } from "react-bootstrap";
import Moment from "moment";
const moment = Moment;

const ViewFormModal = ({ show, onClose, record }) => {
    if (!record) return null;
    const { data } = record;

    const renderImage = (label, url) => {
        if (!url) return null;
        return (
            <div className="mb-3">
                <label>{label}</label>
                <br />
                <img
                    src={url}
                    alt={label}
                    style={{ maxWidth: "150px", display: "block", borderRadius: 4 }}
                />
            </div>
        );
    };

    return (
        <Modal size="lg" show={show} onHide={onClose} centered scrollable>
            <Modal.Header
                closeButton
                style={{ backgroundColor: "#6c757d", color: "white" }}
            >
                <Modal.Title>View Registration</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {/* --- Application Form Section --- */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        background: "#d9ecff",
                        marginTop: "1rem",
                    }}
                >
                    <h1 style={{ fontWeight: "700" }}>Application Form</h1>
                </div>

                {[
                    ["Applicant Name", data.applicantName],
                    ["Course Applied For", data.course],
                    ["Preferred Batch", data.batch],
                    ["Date of Birth", data.dob ? moment(data.dob).format("YYYY-MM-DD") : ""],
                    ["Age", data.age],
                    ["Gender", data.gender],
                    ["Qualification", data.qualification],
                    ["Contact No.", data.contact1],
                    ["Address", data.address],
                    ["Father’s Name", data.fatherName],
                    ["Father’s Contact", data.contact2],
                    ["Father’s Occupation", data.fatherOccupation],
                    ["Mother’s Name", data.motherName],
                    ["Mother’s Occupation", data.motherOccupation],
                    ["Family Size", data.familySize],
                    ["Type of Family", data.familyType],
                    ["Monthly Income", data.income],
                    ["Social Group", data.group],
                    [
                        "Documents Attached",
                        Array.isArray(data.documents)
                            ? data.documents.join(", ")
                            : data.documents || "",
                    ],
                    ["Employment on Completion", data.jobPreference],
                    ["Date of Application", data.doa ? moment(data.doa).format("YYYY-MM-DD") : ""],
                ].map(([label, value], i) => (
                    <div key={i} className="mb-3">
                        <label>{label}</label>
                        <input type="text" className="form-control" value={value || ""} disabled />
                    </div>
                ))}

                {renderImage("Photo", data.photo)}
                {renderImage("Signature", data.signature)}

                {/* --- Declaration from Parent Section --- */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        background: "#d9ecff",
                        marginTop: "1rem",
                    }}
                >
                    <h1 style={{ fontWeight: "700" }}>Declaration from Parent</h1>
                </div>

                {[
                    ["Parent’s Name", data.declarationName],
                    ["Child’s Name", data.declarationChildName],
                    ["Course (CSR Program)", data.declarationCourse],
                    [
                        "Date of Declaration",
                        data.declarationDate
                            ? moment(data.declarationDate).format("YYYY-MM-DD")
                            : "",
                    ],
                ].map(([label, value], i) => (
                    <div key={i} className="mb-3">
                        <label>{label}</label>
                        <input type="text" className="form-control" value={value || ""} disabled />
                    </div>
                ))}

                {renderImage("Parent’s Signature", data.declarationSignature)}

                {/* --- For Office Use Only Section --- */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        background: "#d9ecff",
                        marginTop: "1rem",
                    }}
                >
                    <h1 style={{ fontWeight: "700" }}>FOR OFFICE USE ONLY</h1>
                </div>

                {[
                    ["Training Centre", data.centre],
                    ["Referred By", data.referredBy],
                    ["Registration No.", data.regNo],
                    ["Batch No.", data.batchNo],
                    ["Photocopy of Documents Submitted", data.docsSubmitted],
                    ["Screening Schedule", data.screenSchedule],
                    ["Office Date", data.officeDate ? moment(data.officeDate).format("YYYY-MM-DD") : ""],
                    ["Centre In‑Charge Name", data.inChargeName],
                ].map(([label, value], i) => (
                    <div key={i} className="mb-3">
                        <label>{label}</label>
                        <input type="text" className="form-control" value={value || ""} disabled />
                    </div>
                ))}

                {renderImage("Centre In‑Charge Signature", data.inChargeSignature)}

                {/* --- Upload Documents Section --- */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        background: "#d9ecff",
                        marginTop: "1rem",
                    }}
                >
                    <h1 style={{ fontWeight: "700" }}>Uploaded Documents</h1>
                </div>

                {[1, 2, 3, 4, 5, 6].map((i) => (
                    <div key={i} className="mb-3">
                        {renderImage(`Document ${i}`, data[`uploadDoc${i}`])}
                    </div>
                ))}

                {/* --- Status & Remarks Section --- */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        background: "#d9ecff",
                        marginTop: "1rem",
                    }}
                >
                    <h1 style={{ fontWeight: "700" }}>Status & Remarks</h1>
                </div>

                <div className="mb-3 mt-4">
                    <label>Status</label>
                    <input type="text" className="form-control" value={data.status || ""} disabled />
                </div>
                <div className="mb-3">
                    <label>Remarks</label>
                    <textarea className="form-control" value={data.remarks || ""} disabled />
                </div>

                <div className="mb-3">
                    <label>Created At</label>
                    <input
                        type="text"
                        className="form-control"
                        value={
                            data.createdAt
                                ? moment(data.createdAt.toDate()).format("DD/MM/YY, h:mm a")
                                : ""
                        }
                        disabled
                    />
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ViewFormModal;



// import React from "react";
// import { Modal, Button } from "react-bootstrap"; // make sure you have react‑bootstrap + bootstrap CSS installed
// import Moment from "moment";
// const moment = Moment;

// const ViewFormModal = ({ show, onClose, record }) => {
//     if (!record) return null;

//     const { data } = record;

//     return (
//         <Modal size="lg" show={show} onHide={onClose} centered scrollable>
//             <Modal.Header closeButton style={{ backgroundColor: "#6c757d", color: "white" }}>
//                 <Modal.Title>View Registration</Modal.Title>
//             </Modal.Header>
//             <Modal.Body>
//                 {/* --- Application Form Section --- */}
//                 <div style={{ display: "flex", justifyContent: "center", background: "#d9ecff", marginTop: "1rem", }}>
//                     <h1 style={{ fontWeight: "700", }} className="mb‑3">Application Form</h1>
//                 </div>
//                 <div className="mb‑3">
//                     <label>Applicant Name</label>
//                     <input type="text" className="form-control" value={data.applicantName || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Course Applied For</label>
//                     <input type="text" className="form-control" value={data.course || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Preferred Batch</label>
//                     <input type="text" className="form-control" value={data.batch || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Date of Birth</label>
//                     <input type="date" className="form-control" value={data.dob ? moment(data.dob).format("YYYY‑MM‑DD") : ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Age</label>
//                     <input type="number" className="form-control" value={data.age || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Gender</label>
//                     <input type="text" className="form-control" value={data.gender || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Qualification</label>
//                     <input type="text" className="form-control" value={data.qualification || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Contact No.</label>
//                     <input type="text" className="form-control" value={data.contact1 || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Address</label>
//                     <input type="text" className="form-control" value={data.address || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Father’s Name</label>
//                     <input type="text" className="form-control" value={data.fatherName || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Father’s Contact</label>
//                     <input type="text" className="form-control" value={data.contact2 || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Father’s Occupation</label>
//                     <input type="text" className="form-control" value={data.fatherOccupation || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Mother’s Name</label>
//                     <input type="text" className="form-control" value={data.motherName || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Mother’s Occupation</label>
//                     <input type="text" className="form-control" value={data.motherOccupation || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Family Size</label>
//                     <input type="number" className="form-control" value={data.familySize || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Type of Family</label>
//                     <input type="text" className="form-control" value={data.familyType || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Monthly Income</label>
//                     <input type="text" className="form-control" value={data.income || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Social Group</label>
//                     <input type="text" className="form-control" value={data.group || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Documents Attached</label>
//                     <input type="text" className="form-control" value={data.documents || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Employment on Completion</label>
//                     <input type="text" className="form-control" value={data.jobPreference || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Date of Application</label>
//                     <input type="date" className="form-control" value={data.doa ? moment(data.doa).format("YYYY‑MM‑DD") : ""} disabled />
//                 </div>
//                 {data.photoUrl && (
//                     <div className="mb‑3">
//                         <label>Photo</label>
//                         <img src={data.photoUrl} alt="Applicant Photo" style={{ maxWidth: "150px", display: "block" }} />
//                     </div>
//                 )}
//                 {data.signatureUrl && (
//                     <div className="mb‑3">
//                         <label>Signature</label>
//                         <img src={data.signatureUrl} alt="Signature" style={{ maxWidth: "150px", display: "block" }} />
//                     </div>
//                 )}

//                 {/* --- Declaration from Parent Section --- */}
//                 <div style={{ display: "flex", justifyContent: "center", background: "#d9ecff", marginTop: "1rem", }}>  <h1 style={{ fontWeight: "700", }} className="mt‑4 mb‑3">Declaration from Parent</h1></div>
//                 <div className="mb‑3">
//                     <label>Parent’s Name</label>
//                     <input type="text" className="form-control" value={data.declarationName || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Child’s Name</label>
//                     <input type="text" className="form-control" value={data.declarationChildName || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Course (CSR Program)</label>
//                     <input type="text" className="form-control" value={data.declarationCourse || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Date of Declaration</label>
//                     <input type="date" className="form-control" value={data.declarationDate ? moment(data.declarationDate).format("YYYY‑MM‑DD") : ""} disabled />
//                 </div>
//                 {data.declarationSignatureUrl && (
//                     <div className="mb‑3">
//                         <label>Parent’s Signature</label>
//                         <img src={data.declarationSignatureUrl} alt="Declaration Signature" style={{ maxWidth: "150px", display: "block" }} />
//                     </div>
//                 )}

//                 {/* --- For Office Use Only Section --- */}
//                 <div style={{ display: "flex", justifyContent: "center", background: "#d9ecff", marginTop: "1rem", }}>  <h1 style={{ fontWeight: "700", }} className="mt‑4 mb‑3">For Office Use Only</h1></div>
//                 <div className="mb‑3">
//                     <label>Training Centre</label>
//                     <input type="text" className="form-control" value={data.centre || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Referred By</label>
//                     <input type="text" className="form-control" value={data.referredBy || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Registration No.</label>
//                     <input type="text" className="form-control" value={data.regNo || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Batch No.</label>
//                     <input type="text" className="form-control" value={data.batchNo || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Photocopy of Documents Submitted</label>
//                     <input type="text" className="form-control" value={data.docsSubmitted || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Screening Schedule</label>
//                     <input type="text" className="form-control" value={data.screenSchedule || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Office Date</label>
//                     <input type="date" className="form-control" value={data.officeDate ? moment(data.officeDate).format("YYYY‑MM‑DD") : ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Centre In‑Charge Name</label>
//                     <input type="text" className="form-control" value={data.inChargeName || ""} disabled />
//                 </div>
//                 {data.inChargeSignatureUrl && (
//                     <div className="mb‑3">
//                         <label>In‑Charge Signature</label>
//                         <img src={data.inChargeSignatureUrl} alt="In‑Charge Signature" style={{ maxWidth: "150px", display: "block" }} />
//                     </div>
//                 )}

//                 {/* --- Status & Remarks --- */}
//                 <div className="mb‑3 mt‑4">
//                     <label>Status</label>
//                     <input type="text" className="form-control" value={data.status || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Remarks</label>
//                     <textarea className="form-control" value={data.remarks || ""} disabled />
//                 </div>
//                 <div className="mb‑3">
//                     <label>Created At</label>
//                     <input type="text" className="form-control"
//                         value={data.createdAt ? moment(data.createdAt.toDate()).format("DD/MM/YY, h:mm a") : ""}
//                         disabled />
//                 </div>
//             </Modal.Body>
//             <Modal.Footer>
//                 <Button variant="secondary" onClick={onClose}>Close</Button>
//             </Modal.Footer>
//         </Modal>
//     );
// };

// export default ViewFormModal;


// // import React from "react";
// // import { Modal, Button } from "react-bootstrap"; // ensure you have react‑bootstrap installed
// // import Moment from "moment";
// // const moment = Moment;

// // const ViewFormModal = ({ show, onClose, record }) => {
// //     if (!record) return null;

// //     const { data } = record;

// //     return (
// //         <Modal size="lg" show={show} onHide={onClose} centered scrollable>
// //             <Modal.Header closeButton>
// //                 <Modal.Title>View Registration (ID: {record.id})</Modal.Title>
// //             </Modal.Header>
// //             <Modal.Body>
// //                 {/* Example: Application Form Tab */}
// //                 <h5>Application Form</h5>
// //                 <div className="mb‑3">
// //                     <label>Applicant Name</label>
// //                     <input type="text" className="form-control" value={data.applicantName || ""} disabled />
// //                 </div>
// //                 <div className="mb‑3">
// //                     <label>Course Applied For</label>
// //                     <select className="form-select" value={data.course || ""} disabled>
// //                         <option value="">Select Course</option>
// //                         <option>Retail Sales Assistant</option>
// //                         <option>Warehouse Associate</option>
// //                         <option>Digital Mitra</option>
// //                         <option>IT Customer Care Executive</option>
// //                     </select>
// //                 </div>
// //                 {/* Continue for other fields similarly... */}
// //                 <div className="mb‑3">
// //                     <label>Date of Application</label>
// //                     <input type="date" className="form-control"
// //                         value={data.doa ? moment(data.doa).format("YYYY‑MM‑DD") : ""}
// //                         disabled />
// //                 </div>

// //                 {/* Photo & Signature preview (if stored as URL) */}
// //                 {data.photoUrl && (
// //                     <div className="mb‑3">
// //                         <label>Photo</label>
// //                         <img src={data.photoUrl} alt="Applicant Photo" style={{ maxWidth: "150px", display: "block" }} />
// //                     </div>
// //                 )}
// //                 {data.signatureUrl && (
// //                     <div className="mb‑3">
// //                         <label>Signature</label>
// //                         <img src={data.signatureUrl} alt="Signature" style={{ maxWidth: "150px", display: "block" }} />
// //                     </div>
// //                 )}

// //                 {/* Declaration Tab */}
// //                 <h5 className="mt‑4">Declaration from Parent</h5>
// //                 <div className="mb‑3">
// //                     <label>Parent’s Name</label>
// //                     <input type="text" className="form-control" value={data.declarationName || ""} disabled />
// //                 </div>
// //                 <div className="mb‑3">
// //                     <label>Child’s Name</label>
// //                     <input type="text" className="form-control" value={data.declarationChildName || ""} disabled />
// //                 </div>
// //                 {/* Continue similarly... */}

// //                 {/* FOR OFFICE USE ONLY Tab */}
// //                 <h5 className="mt‑4">For Office Use Only</h5>
// //                 <div className="mb‑3">
// //                     <label>Training Centre</label>
// //                     <input type="text" className="form-control" value={data.centre || ""} disabled />
// //                 </div>
// //                 <div className="mb‑3">
// //                     <label>Registration No.</label>
// //                     <input type="text" className="form-control" value={data.regNo || ""} disabled />
// //                 </div>
// //                 {/* Continue for other fields... */}

// //                 <div className="mb‑3">
// //                     <label>Status</label>
// //                     <input type="text" className="form-control" value={data.status || ""} disabled />
// //                 </div>
// //                 <div className="mb‑3">
// //                     <label>Remarks</label>
// //                     <textarea className="form-control" value={data.remarks || ""} disabled />
// //                 </div>

// //                 <div className="mb‑3">
// //                     <label>Created At</label>
// //                     <input type="text" className="form-control"
// //                         value={data.createdAt ? moment(data.createdAt.toDate()).format("DD/MM/YY, h:mm a") : ""}
// //                         disabled />
// //                 </div>
// //             </Modal.Body>
// //             <Modal.Footer>
// //                 <Button variant="secondary" onClick={onClose}>Close</Button>
// //             </Modal.Footer>
// //         </Modal>
// //     );
// // };

// // export default ViewFormModal;
